import { AxiosResponse } from "axios"
import {UserData, NewUserData} from "../../data/interfaces/userInfo"
import { PostMessage } from "../../data/loginService"


export const LoginNav = (success: boolean, user: NewUserData): string => {
    if(user.birthDate){
        let year = user.birthDate.substring(0, 4);
        if(parseInt(year) < 1901){
            user.birthDate = ""
        }
    }
    if (!success) {
        return "UserLogin"
    }
    if(user.isMFAVerified){
        PostMessage(user,"LastForm")
        return "UserLogin"
    }
    if (!user.birthDate || !(user.mfaEmail || user.mfaPhone)) {
        return "SaveUserInfo"
    }
    else {
        return "SendCode"
    }
}